module.exports = __webpack_public_path__ + "img/that-picture-5.1c405741.png";